import { HStack, Input } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";

const DateFilter = observer(() => {
  const { pageStore } = useStores();

  const handleStartDateChange = (e) => {
    const newStartDate = e.target.value;
    pageStore.updateStartDate(newStartDate);

    if (newStartDate > pageStore.end_date) {
      pageStore.updateEndDate("");
    }
  };

  return (
    <HStack>
      <Input
        type="date"
        value={pageStore?.start_date || ""}
        width={"300px"}
        border={"none"}
        style={{
          background: "#333",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
        }}
        onChange={handleStartDateChange}
      />
      <Input
        value={pageStore?.end_date || ""}
        type="date"
        width={"300px"}
        border={"none"}
        style={{
          backgroundColor: "#333",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
        }}
        onChange={(e) => pageStore.updateEndDate(e.target.value)}
      />
    </HStack>
  );
});

export default DateFilter;